import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import ProgressBar from "./ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import CommunityContent from "../Community/CommunityContent";
import { useEffect, useState } from "react";
import { getAllCreators } from "../../redux/actions/user.dispatcher";
import SubscribeVideoDrawer from "../Common/SubscribeVideoDrawer";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/config/config";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const FollowCreator = ({
  setStep,
  progress,
  setProgress,
  formData,
  handleCheckboxChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allCreators } = useSelector((state) => state.user);
  const [drawerState, setDrawerState] = useState(false);
  const [creatorData, setCreatorData] = useState({});
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    dispatch(getAllCreators());
  }, []);

  const finalizeSignUp = async () => {
    try {
      const response = await axiosInstance.post(`/user/finalizeSignUp`, {
        user: formData.user,
      });

      if (response) {
        localStorage.setItem("startTour", "true"); // Store tour trigger
        navigate("/dashboard"); // Redirect to dashboard
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Elements stripe={stripePromise}>
      <Box display="flex" flexDirection="column" alignItems="center" p={4}>
        <Box width={{ xs: "90vw", md: "70vw" }}>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "32px",
              mb: 2,
              textAlign: "left",
            }}
          >
            Personalize Experience
          </Typography>
          <ProgressBar progress={progress} setProgress={setProgress} />
        </Box>

        <Box width={{ xs: "90vw", md: "70vw" }} mt={4}>
          <Typography variant="h6" fontWeight="bold" textAlign="left">
            Follow creators you like...
          </Typography>
          <CommunityContent
            type={"creators"}
            allData={allCreators || []}
            setup
            setDrawerState={setDrawerState}
            setCreatorData={setCreatorData}
          />

          <SubscribeVideoDrawer
            drawerState={drawerState}
            setDrawerState={setDrawerState}
            creatorData={creatorData}
            type={creatorData ? "creator" : "video"}
            setSuccess={setSuccess}
          />

          <Box display="flex" flexDirection="row" gap={5} mt={4}>
            <SecondaryBtn
              text="Previous"
              noIcon
              width="40%"
              onClick={() => setStep(3)}
            />
            <CustomBtn
              text="Next"
              noIcon
              width="40%"
              onClick={() => {
                setProgress(100);
                navigate("/dashboard"); // Redirect to dashboard
              }}
            />
          </Box>
          <Box display="flex" flexDirection="row" gap={5}>
            <CustomBtn text="Save" noIcon width="40%" />
          </Box>
        </Box>
      </Box>
    </Elements>
  );
};

export default FollowCreator;
